<template>
  <div>
    <div v-if="uid != ''">
      <h1 class="documentTitle" v-if="notLoginConfirmed">
        {{ $t("authCheck.noLoginInfo") }}
        <b-button class="ml-3 mr-1 pt-dot1 pb-dot1"  variant="primary" v-b-modal.loginFloat>
          {{ $t("common.login" ) }}
        </b-button>
      </h1>

      <h1 class="documentTitle" v-else-if="!loginUser">
        <b-spinner type="grow" variant="primary"></b-spinner>
         {{ $t("authCheck.doingLogin") }}
        <b-spinner type="grow" variant="primary"></b-spinner>
      </h1>

      <h1 class="documentTitle" v-else-if="!loginUserBinded || !pageBindFinished">
        <b-spinner type="grow" variant="primary"></b-spinner>
         {{ $t("authCheck.doingInit") }}
        <b-spinner type="grow" variant="primary"></b-spinner>
      </h1>

      <h1 class="documentTitle"  v-else-if="pageUser && isPageUserWithdrawn">
        탈퇴한 사용자 페이지입니다.
      </h1>  

      <div v-else-if="!isLoginUserPageUserReadable">
        <ul v-if="friendRequested"  class="m-2 ml-5 p-2 gothic">
          <li class="mb-2">
            {{$t("authCheck.onlyOpenToFriend")}}
            {{$t("authCheck.alreadyRequestedFriend")}}

            <b-button size="sm" variant="primary" v-if="isIdLoginUserFriend(uid)" @click="cancelFriend(true)" style="vertical-align: 1px;" class="mr-2 pt-dot1 pb-dot1" :disabled="requestDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="removeCancelSpinner"></b-spinner>
              {{ $t("authCheck.deleteMyFriendAndCancelRequestFriend")}}
            </b-button>

            <b-button size="sm" class="pt-dot1 pb-dot1" variant="primary" @click="cancelFriend(false)" style="vertical-align: 1px;"  :disabled="requestDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="cancelSpinner"></b-spinner>
              {{ $t("authCheck.cancelRequestFriend") }}
            </b-button>

          </li>
          <li v-if="isIdLoginUserFriend(uid)" class="mb-2">
            {{ $t("authCheck.ownerisIdLoginUserFriend") }}
            <b-button size="sm" variant="secondary" @click="removeMyFriend()" style="vertical-align: 1px;" class="mr-2 pt-dot1 pb-dot1" :disabled="addDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="removeSpinner"></b-spinner>
              {{ $t("authCheck.deleteMyFriend") }}
            </b-button>
          </li>
          <li v-else class="mb-2">
            {{ $t("authCheck.ownerIsNotMyFriend") }}
            <b-button size="sm" variant="secondary" @click="addMyFriend()" style="vertical-align: 1px;" class="mr-2 pt-dot1 pb-dot1" :disabled="addDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="addSpinner"></b-spinner>
              {{ $t("authCheck.addToMyFriend")}}
            </b-button>
          </li>
        </ul>

        <ul v-else class="m-2 ml-5 p-2 gothic">
          <li class="mb-2">
            {{$t("authCheck.onlyOpenToFriend")}}
            <b-button size="sm" v-if="!isIdLoginUserFriend(uid)" variant="primary" @click="requestFriend(true)" style="vertical-align: 1px;" class="mr-2 pt-dot1 pb-dot1" :disabled="requestDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="addRequestSpinner"></b-spinner>
              {{ $t("authCheck.addToMyFriendAndSendRequestFriend")}}
            </b-button>
            <b-button size="sm" class="pt-dot1 pb-dot1" variant="primary" @click="requestFriend(false)" style="vertical-align: 1px;" :disabled="requestDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="requestSpinner"></b-spinner>
              {{ $t("authCheck.sendFriendRequest")}}
            </b-button>
          </li>
          <li v-if="isIdLoginUserFriend(uid)" class="mb-2">
            {{ $t("authCheck.ownerisIdLoginUserFriend") }}
            <b-button size="sm" variant="secondary" @click="removeMyFriend()" style="vertical-align: 1px;" class="mr-2 pt-dot1 pb-dot1" :disabled="addDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="removeSpinner"></b-spinner>
              {{ $t("authCheck.deleteMyFriend") }}
            </b-button>
          </li>
          <li v-else class="mb-2">
            {{ $t("authCheck.ownerIsNotMyFriend") }}
            <b-button size="sm" variant="secondary" @click="addMyFriend()" style="vertical-align: 1px;" class="mr-2 pt-dot1 pb-dot1" :disabled="addDisabled">
              <b-spinner small type="grow" class="mr-1" v-if="addSpinner"></b-spinner>
              {{ $t("authCheck.addToMyFriend") }}
            </b-button>
          </li>
        </ul>
      </div>
      <div v-else>
        <slot></slot>
      </div>
    </div>
    <div v-else-if="did != ''">

      <h1 class="documentTitle" v-if="notLoginConfirmed">
        {{ $t("authCheck.noLoginInfo") }}
        <b-button class="ml-3 mr-1 pt-dot1 pb-dot1"  variant="primary" v-b-modal.loginFloat>
          {{ $t("common.login" ) }}
        </b-button>
      </h1>

      <h1 class="documentTitle" v-else-if="!loginUser">
        <b-spinner type="grow" variant="primary"></b-spinner>
         {{ $t("authCheck.doingLogin") }}
        <b-spinner type="grow" variant="primary"></b-spinner>
      </h1>

      <h1 class="documentTitle" v-else-if="!loginUserBinded || !pageBindFinished">
        <b-spinner type="grow" variant="primary"></b-spinner>
         {{ $t("authCheck.doingInit") }}
        <b-spinner type="grow" variant="primary"></b-spinner>
      </h1>

      <div v-else-if="pageDevice && !isLoginUserPageItemReadable">
        <ul class="m-2 ml-5 p-2 gothic">
          <li class="mb-2">
            이 기기는 모두에게 비공개이거나 친구에게만 공개되어 있습니다.
            <router-link :to="{ name: 'tinkUser', params: { uid: pageDevice.owner } }" custom v-slot="{ navigate }">
              <b-button size="sm" variant="primary" @click="navigate" @keypress.enter="navigate" role="link" style="vertical-align: 1px;" class="mr-1 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 cursor-pointer">
                기기 소유자 페이지로 가기
              </b-button>
            </router-link>
            <b-button size="sm" variant="secondary"  @click="goBack()" style="vertical-align: 1px;" class="mr-1 pt-dot1 pb-dot1 pl-1 pr-1">
              이전 페이지로 돌아가기
            </b-button>
          </li>
        </ul>
      </div>
      <div v-else>
        <slot></slot>
      </div>
    </div>
    <div v-else-if="sid != ''">

      <h1 class="documentTitle" v-if="notLoginConfirmed">
        {{ $t("authCheck.noLoginInfo") }}
        <b-button class="ml-3 mr-1 pt-dot1 pb-dot1" variant="primary" v-b-modal.loginFloat>
          {{ $t("common.login" ) }}
        </b-button>
      </h1>

      <h1 class="documentTitle" v-else-if="!loginUser">
        <b-spinner type="grow" variant="primary"></b-spinner>
         {{ $t("authCheck.doingLogin") }}
        <b-spinner type="grow" variant="primary"></b-spinner>
      </h1>

      <h1 class="documentTitle" v-else-if="!loginUserBinded || !pageBindFinished">
        <b-spinner type="grow" variant="primary"></b-spinner>
         {{ $t("authCheck.doingInit") }}
        <b-spinner type="grow" variant="primary"></b-spinner>
      </h1>

      <div v-else-if="!isLoginUserPageItemReadable">
        <ul class="m-2 ml-5 p-2 gothic">
          <li class="mb-2" v-if="pageDevice != null">
            이 센서는 모두에게 비공개이거나 친구에게만 공개되어 있습니다.

            <router-link :to="{ name: 'tinkUser', params: { uid: pageDevice.owner } }" custom v-slot="{ navigate }">
              <b-button size="sm" variant="primary" @click="navigate" @keypress.enter="navigate" role="link" style="vertical-align: 1px;" class="mr-1 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 cursor-pointer">
                센서 소유자 페이지로 가기
              </b-button>
            </router-link>

            <b-button size="sm" variant="secondary"  @click="goBack()" style="vertical-align: 1px;" class="mr-1 pt-dot1 pb-dot1 pl-1 pr-1">
              이전 페이지로 돌아가기
            </b-button>
          </li>
        </ul>
      </div>

      <div v-else>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>

import user from "@/mixins/user.js"
import uiUtil from "@/mixins/util.js"
import functions from "@/mixins/functions.js"

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

export default {
  name: 'authCheck',
  mixins: [user, uiUtil, functions],
  props: {
    pageBindFinished: {
      type: Boolean,
      default: false,
    },
    pageUser: {
      type: Object,
      default: null,
    },
    pageDevice: {
      type: Object,
      default: null,
    },
    pageSensor: {
      type: Object,
      default: null,
    },
    uid: {
      type: String,
      default: "",
    },
    did: {
      type: String,
      default: "",
    },
    sid: {
      type: String,
      default: "",
    },
  },
  created: function() {
  },
  mounted: function() {
    // this.$log.debug("uid=", this.uid, "did=", this.did, "sid=", this.sid, "pageUser=", this.pageUser, "pageDevice=", this.pageDevice, "pageSensor=", this.pageSensor, "pageBindFinished=", this.pageBindFinished);
  },
  updated: function() {
    // this.$log.debug("uid=", this.uid, "did=", this.did, "sid=", this.sid, "pageUser=", this.pageUser, "pageDevice=", this.pageDevice, "pageSensor=", this.pageSensor, "pageBindFinished=", this.pageBindFinished);
    // this.$log.debug(this.isLoginUserPageItemReadable)
  },
  data() {
    return {
      // "loginDisabled": true,
      "friendRequested": false,

      "addSpinner" : false,
      "requestSpinner" : false,
      "cancelSpinner" : false,
      "removeSpinner" : false,
      "addRequestSpinner" : false,
      "removeCancelSpinner" : false,

      "requestDisabled" : false,
      "addDisabled" : false,
    }
  },
  methods: {

    requestFriend: function(addFlag = false) {
      if(addFlag) {
        this.addMyFriend();
        this.addRequestSpinner = true;
      }
      else {
        this.requestSpinner = true;
      }
      this.requestDisabled = true;

      let toSend = {
        uid: this.uid,
        loginUserDisplayName: this.loginUser.displayName,
      };
      toSend.loginUserEmail = (this.loginUser.emailVerified)? this.loginUser.email: "";

      this.postJSONWithAuth(this.functionsServer + "/app/requestFriend", toSend)
      .then(result=> {
        if(result.status != 200) {
          this.makeToast("danger", this.$t("authCheck.sendFriendRequestFail"), this.$t("authCheck.sendFriendRequestFailBody", {
            "status": result.status,
            "statusText": result.statusText
          }))
        }
        else {
          if(result.data.success) {
            this.friendRequested = true;
            this.makeToast("success", this.$t("authCheck.sendFriendRequestSuccess"), this.$t("authCheck.sentFriendRequest"));
          }
          else {
            if(result.data.error == 1) {
              this.makeToast("danger", this.$t("authCheck.sendFriendRequestFail"), this.$t("tHeader.canNotAddMySelf"));
            }
            else if(result.data.error == 2) {
              this.makeToast("danger", this.$t("authCheck.sendFriendRequestFail"), this.$t("tHeader.alreadyAddedAsFriend"));
            }
            else if(result.data.error == 3) {
              this.friendRequested = true;
              this.makeToast("danger", this.$t("authCheck.sendFriendRequestFail"), this.$t("authCheck.alreadySentFriendRequest"));
            }
            else if(result.data.error == 4) {
              this.makeToast("danger", this.$t("authCheck.sendFriendRequestFail"), this.$t("authCheck.couldNotGetUserInfo"));
            }
          }
        }
        if(addFlag) {
          this.addRequestSpinner = false;
        }
        else {
          this.requestSpinner = false;
        }
        window.setTimeout(()=> {
          this.requestDisabled = false;
        }, 5000);
      })
      .catch(error => {
        this.makeToast("danger", this.$t("authCheck.sendFriendRequestFail"), this.$t("tHeader.notSendFriendRequestError"), {
          detailed: error
        });
        if(addFlag) {
          this.addRequestSpinner = false;
        }
        else {
          this.requestSpinner = false;
        }
        window.setTimeout(()=> {
          this.requestDisabled = false;
        }, 5000);
      });
    },

    cancelFriend: function(removeFlag = false) {
      if(removeFlag) {
        this.removeMyFriend();
        this.removeCancelSpinner = true;
      }
      else {
        this.removeSpinner = true;
      }
      this.requestDisabled = true;

      this.postJSONWithAuth(this.functionsServer + "/app/cancelFriend", {
        uid: this.uid
      })
      .then(result=> {
        if(result.status != 200) {
          this.makeToast("danger", this.$t("authCheck.cancelFriendRequestFail"), this.$t("authCheck.cancelFriendRequestFailBody", {
            status: result.status,
            statusText: result.statusText
          }));
        }
        else {
          if(result.data.success) {
            this.friendRequested = false;
            this.makeToast("success", this.$t("authCheck.cancelFriendRequestSuccess"), this.$t("authCheck.cancelFriendRequestSuccessBody"));
          }
          else {
            if(result.data.error == 1) {
              this.makeToast("danger", this.$t("authCheck.cancelFriendRequestFail"), this.$t("authCheck.neverRequestedFriend"));
            }
            else {
              this.makeToast("danger", this.$t("authCheck.cancelFriendRequestFail"), this.$t("authCheck.couldNotGetUserInfo"));
            }
          }
        }
        if(removeFlag) {
          this.removeCancelSpinner = false;
        }
        else {
          this.removeSpinner = false;
        }
        window.setTimeout(()=> {
          this.requestDisabled = false;
        }, 5000);
      })
      .catch(error => {
        this.makeToast("danger", this.$t("authCheck.cancelFriendRequestFail"), this.$t("authCheck.notSendCancelFriendRequest", {detailed: error}));
        if(removeFlag) {
          this.removeCancelSpinner = false;
        }
        else {
          this.removeSpinner = false;
        }
        window.setTimeout(()=> {
          this.requestDisabled = false;
        }, 5000);
      });
    },

    removeMyFriend: function() {
      this.addDisabled = true;

      db.collection("users").doc(this.loginUser.id).update({
        "frApp": firebase.firestore.FieldValue.arrayRemove(this.uid)
      })
      .then(() => {
        this.makeToast("success", this.$t("authCheck.deleteFriendSuccess"), this.$t("authCheck.deleteFriendSuccessBody"))
        window.setTimeout(()=> {
          this.addDisabled = false;
        }, 5000);
      })
      .catch(error => {
        this.makeToast("danger", this.$t("authCheck.deleteFriendFail"), )
        window.setTimeout(()=> {
          this.addDisabled = false;
        }, 5000);
      })
    },

    addMyFriend: function() {
      this.addDisabled = true;
      db.collection("users").doc(this.loginUser.id).update({
        "frApp": firebase.firestore.FieldValue.arrayUnion(this.uid)
      })
      .then(() => {
        this.makeToast("success", this.$t("common.addFriendSuccess"), this.$t("common.addFriendSuccessbody"))
        window.setTimeout(()=> {
          this.addDisabled = false;
        }, 5000);
      })
      .catch(error => {
        this.makeToast("danger", this.$t("authCheck.addFriendFail"), this.$t("authCheck.addFriendFailBody", {
          detailed: error
        }))
        window.setTimeout(()=> {
          this.addDisabled = false;
        }, 5000);
      })
    },
  }
}
</script>
